import { useCallback, useEffect, useMemo, useRef, useState } from "react";
export function usePrybar(options) {
    const [isOpen, setIsOpen] = useState(false);
    const { onClose: userOnClose, shortcutKey = "k", disableShortcut = false, IconComponent, userId, ...configProps } = options;
    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => {
        setIsOpen(false);
        userOnClose?.();
    }, [userOnClose]);
    const toggle = useCallback(() => setIsOpen((prev) => !prev), []);
    useEffect(() => {
        if (disableShortcut)
            return;
        const handler = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === shortcutKey) {
                e.preventDefault();
                e.stopPropagation();
                setIsOpen((prev) => !prev);
            }
        };
        document.addEventListener("keydown", handler, true);
        return () => document.removeEventListener("keydown", handler, true);
    }, [shortcutKey, disableShortcut]);
    const configPropsRef = useRef(configProps);
    configPropsRef.current = configProps;
    const config = useMemo(() => ({
        ...configPropsRef.current,
        navigate: configPropsRef.current.navigate ?? (() => { }),
        onClose: close,
        // HealthOS patch: recompute when the dynamic, route-derived fields change so
        // suggestions + appContext stay live (callers pass stable memoised refs).
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [close, configProps.suggestions, configProps.appContext]);
    return { config, isOpen, IconComponent, userId, open, close, toggle };
}
//# sourceMappingURL=use-prybar.js.map